// @flow
import React from 'react';
import { Form, FormikProps, Formik, FormikHelpers, FormikValues } from 'formik';
import * as Yup from 'yup';
import cogoToast from 'cogo-toast';
import api from 'apiClient/api';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import { StringUtil } from 'utils/StringUtil';
import { FormButton } from 'components/molecules/formButton';
import { FormInput } from 'components/molecules/formInput';
import { FormTextArea } from 'components/molecules/formTextArea';
import { FormDropdown } from 'components/molecules/formDropdown';
// eslint-disable-next-line
import styles from "./styles.scss";
import { getGclid } from 'utils/GetGclid';

// const API_ENDPOINT = 'sendEmail.json';
const API_ENDPOINT = 'postLead'; // For  Sales force API

type Props = {
  onSubmitSuccess: () => void,
  isMobile: boolean,
  salesEmail?: boolean,
  callPostLeadAPI?: boolean,
  utmParameters: {
    UTMSource: string,
    UTMMedium: string,
    UTMCampaign: string,
    UTMDisplay: string,
    UTMTerm: string,
    UTMContent: string,
    CampaignCode: string,
    ProjectInterested: string,
  },
  pdfUrl?: string,
  verticalId: number | null,
};

type State = {
  data: {
    subject?: string,
    firstname?: string,
    lastname?: string,
    getInTouch_gclid_field?: string,
    emailaddress?: string,
    mobilenumber?: string,
    country?: string,
    remarks?: string,
    DialingCode?: string,
    interestedIn?: string,
  },
};

const initialState: State = {
  data: {
    subject: '',
    firstname: '',
    lastname: '',
    getInTouch_gclid_field: '',
    emailaddress: '',
    mobilenumber: '',
    remarks: '',
    country: CURRENT_COUNTRY_CODE,
    DialingCode: CURRENT_COUNTRY_CODE,
    pdfUrl: '',
    interestedIn: '',
  },
};

export class GetInTouchForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ...initialState,
      selectedCountryName: 'IND',
      isSubmitted: false,
    };
    this.state.data.subject = this.props.verticalId
      ? this.props.verticalId
      : -1;
  }
  render = () => {
    const buttonMode = this.props.isMobile ? 'transparent' : 'dark';
    const country_code = [
      { value: '+91', label: 'IND' },
      { value: '+1', label: 'U.S' },
      { value: '+968', label: 'OM' },
      { value: '+65', label: 'SG' },
      { value: '+44', label: 'U.K' },
      { value: '+61', label: 'AUS' },
      { value: ' ', label: 'OTHERS' },
    ];

    const interested_options = [
      {
        label: "I'm an interested homebuyer",
        value: "I'm an interested homebuyer",
      },
      {
        label: "I'm a real estate agent",
        value: "I'm a real estate agent",
      },
      {
        label: "I'm a vendor or partner",
        value: "I'm a vendor or partner",
      },
      {
        label: 'Other (please specify in the message section)',
        value: 'Other',
      },
    ];

    return (
      <div className={'get-in-touch-form'}>
        <Formik
          initialValues={this.state.data}
          onSubmit={this.onSubmit}
          validationSchema={this.getSchema()}
        >
          {(props: FormikProps<State>) => (
            <Form>
              <FormInput
                id={'get-in-touch-firstname'}
                name={'firstname'}
                label={'First Name'}
                placeholder={'First Name'}
                type={'text'}
                value={props.values['firstname']}
              />
              <FormInput
                id={'get-in-touch-lastname'}
                name={'lastname'}
                label={'Last Name'}
                placeholder={'Last Name'}
                type={'text'}
                value={props.values['lastname']}
              />
               <FormInput
                id={'getInTouch_gclid_field'}
                name={'getInTouch_gclid_field'}
                type={'hidden'}
                value={props.values['getInTouch_gclid_field']}
              />
              <FormInput
                id={'get-in-touch-emailaddress'}
                name={'emailaddress'}
                label={'Email Address'}
                placeholder={'Email Address'}
                type={'email'}
                value={props.values['emailaddress']}
              />
              <div className={'contact-number-container'}>
                <FormDropdown
                  name={'country'}
                  label={'Country'}
                  placeholder={''}
                  options={country_code}
                  value={props.values['country']}
                  selected_country={e =>
                    this.setState({ selectedCountryName: e })
                  }
                  onDropDownChange={e => (
                    (props.values['DialingCode'] = e.value),
                    (props.values['mobilenumber'] =
                      initialState.data.mobilenumber)
                  )}
                  showPlaceholder={true}
                />
                <FormInput
                  name={'DialingCode'}
                  label={''}
                  placeholder={'CODE'}
                  type={'text'}
                  disabled={props.values['country'] !== ' '}
                  value={
                    props.values['country'] !== ' '
                      ? props.values['country']
                      : props.values['DialingCode']
                  }
                />
                <FormInput
                  id={'get-in-touch-mobilenumber'}
                  name={'mobilenumber'}
                  label={'Mobile Number'}
                  placeholder={'Mobile Number'}
                  value={props.values['mobilenumber']}
                  type={'number'}
                />
              </div>
              <FormDropdown
                name={'interestedIn'}
                placeholder={"I'm interested in"}
                options={interested_options}
                value={props.values['interestedIn']}
                showPlaceholder={true}
              />
              {this.props.type !== 'brochure' && (
                <FormTextArea
                  id={'get-in-touch-message'}
                  name={'remarks'}
                  label={'Message'}
                  placeholder={'Message'}
                  value={props.values['remarks']}
                  rows={2}
                />
              )}
              <FormButton
                disabled={props.isSubmitting}
                mode={buttonMode}
                onClick={() => this.setState({ isSubmitted: true })}
              />
            </Form>
          )}
        </Formik>
      </div>
    );
  };

  getValidation = () => {
    return Yup.string()
      .trim()
      .required('Please select an option');
  };

  // TODO: Common component for toast?
  onSubmit = (values: FormikValues, actions: FormikHelpers<FormikValues>) => {
    const trimmedValues = this.trimValues(values);
    const { callPostLeadAPI, salesEmail } = this.props;
    const pageUrl = `${window.location.origin}${window.location.pathname}`;
    const {
      UTMSource,
      UTMMedium,
      UTMCampaign,
      UTMDisplay,
      UTMTerm,
      UTMContent,
      CampaignCode,
      ProjectInterested,
    } = this.props.utmParameters;
    const reference_no = this.props.referenceNumber;
    const rental_name = this.props.rentalName;
    const is_rental = !!this.props.rental;
    this.state.isSubmitted && actions.setSubmitting(true);
    const { hide: hideLoader } = cogoToast.loading(
      'Submitting your information...',
      {
        hideAfter: 0,
      }
    );

    getGclid('getInTouch')
    const getInTouchCclidField = document.getElementById('getInTouch_gclid_field')
    const payload = {
      ...trimmedValues,
      UTMSource,
      UTMMedium,
      UTMCampaign,
      UTMDisplay,
      UTMTerm,
      UTMContent,
      CampaignCode,
      ProjectInterested,
      reference_no,
      rental_name,
      is_rental,
      // salesEmail,
    };
    payload.salesEmail = salesEmail;
    payload.isSalesForce = true;
    payload.Gclid = getInTouchCclidField.value;
    if (!callPostLeadAPI) {
      payload.link = pageUrl;
      payload.isSalesForce = false;
    }

    function downloadBrochure(url) {
      window.open(url, '_blank');
    }

    api
      .post(API_ENDPOINT, payload)
      .then(res => {
        if (res.data.status === 'success') {
          hideLoader();
          setTimeout(() => {
            cogoToast.success('Submitted your information successfully!');
            this.props.onSubmitSuccess && this.props.onSubmitSuccess();
          }, 1000);
          {
            this.props.type === 'brochure' &&
              downloadBrochure(this.props.pdfUrl);
          }
          actions.resetForm({ ...initialState });
          if (this.props.type !== 'brochure') {
            window.location.href = '/thank-you';
          }
        } else {
          hideLoader();
          setTimeout(() => {
            cogoToast.error(res.data.message);
          }, 1000);
        }
      })
      .catch(error => {
        hideLoader();
        setTimeout(() => {
          cogoToast.error('Failed to submit your information');
        }, 1000);
      })
      .finally(() => {
        this.setState({ isSubmitted: false });
        actions.setSubmitting(false);
      });
  };

  trimValues = (values: FormState): FormState => {
    const trimmed = Object.keys(values).reduce((trimmed, key) => {
      if (!trimmed[key]) {
        delete trimmed.country;
        trimmed[key] = values[key].toString().trim();
      }

      trimmed.remarks =
        trimmed.interestedIn !== "I'm interested in" &&
        trimmed.interestedIn !== undefined
          ? `${trimmed.interestedIn}\n${trimmed.remarks}`
          : trimmed.remarks;
      delete trimmed.interestedIn;
      return trimmed;
    }, {});

    delete trimmed.getInTouch_gclid_field;

    return trimmed;
  };

  checkCountrySelected = () => {
    switch (this.state.selectedCountryName) {
      case 'IND':
      case 'U.S':
        return StringUtil.regexPatterns.phoneINDUS;
      case 'OM':
      case 'SG':
        return StringUtil.regexPatterns.phoneOMSG;
      case 'U.K':
        return StringUtil.regexPatterns.phoneUK;
      case 'AUS':
        return StringUtil.regexPatterns.phoneAUS;
      default:
        return StringUtil.regexPatterns.phone;
    }
  };

  getSchema = () => {
    const schema = {
      firstname: Yup.string().trim(),
      lastname: Yup.string()
        .trim()
        .required('Please enter your Last Name'),
      emailaddress: Yup.string()
        .trim()
        .email('Please enter a valid email')
        .required('Please enter your email'),
      // Commenting the below code for Salesforce API
      // .when('mobilenumber', function(v) {
      //   if (v == null || v === '') {
      //     return this.required(
      //       'Please enter your Email address or Phone number'
      //     );
      //   }
      // }),
      mobilenumber: Yup.string()
        .trim()
        .required('Please enter your phone number')
        .matches(this.checkCountrySelected(), 'Invalid phone number'),
      DialingCode: Yup.string()
        .trim()
        .required('CODE')
        .matches(/^(\+?\d{1,4}|\d{1,4})$/, 'CODE'),
      // Commenting the below code for Salesforce API
      // .when('emailaddress', function(v) {
      // if (v == null || v === '') {
      //   return this.required('Please enter your Phone number');
      // }
      // }),
      message: Yup.string()
        .trim()
        .max(150, 'Please enter a shorter message'),
      interestedIn: this.state.isSubmitted
        ? this.getValidation()
        : Yup.string().trim(),
    };

    return Yup.object().shape(schema, [['mobilenumber', 'emailaddress']]);
  };
}
